<div *ngIf="loadComplete" class="container-block">
  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="Thông số cơ bản" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <div nz-row style="margin-bottom: 16px;">
            <div nz-col nzSpan="12" class="d-flex justify-content-around align-items-center">
              <span nz-icon nzType="column-width" nzTheme="outline"></span>
              <input  [ngModel]="class['frame-news-group']['width'] | vhnumber"
                (ngModelChange)="class['frame-news-group']['width'] = $event + 'px'"
                (blur)="updateClass()"  type="number" style="width: 70%;background-color: transparent;border: none;"/>
            </div>
            <div nz-col nzSpan="12" class="d-flex justify-content-around align-items-center">
              <span nz-icon nzType="column-height" nzTheme="outline"></span>
            <input  [ngModel]="class['frame-news-group']['height']  | vhnumber"
            (ngModelChange)="class['frame-news-group']['height'] = $event + 'px'"
              (blur)="updateClass()" type="number" style="width: 70%;background-color: transparent;border: none;"/>
            </div>
          </div>
          <!-- Lựa chọn {{'hien_thi' | translate}} mobile -->
          <app-hide-show-config
                        [device]="device"
                        [elementChoosing]="objectChoosing">
          </app-hide-show-config>
          <!-- Lựa chọn tự động có dãn của frame -->
          <div class="item">
            <div class="hidden-text" style="display: flex; align-items: center">
              Tự động co dãn
              <span style="padding-left: 5px; color: red" nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="Việc bật/tắt chức năng này có thể gây vỡ bố cục. Cần bật/tắt chức năng này trước khi kéo thả"></span>
            </div>
            <nz-switch [ngModel]="config['frame-news-group']['auto_resize']" nz-popconfirm [nzControl]="true"
              nzOkText="Ok" nzCancelText="Hủy"
              nzPopconfirmTitle="Việc bật/tắt chức năng này có thể gây vỡ bố cục! Xác nhận thay đổi?"
              nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="config['frame-news-group']['auto_resize'] = !config['frame-news-group']['auto_resize']; updateConfig()"></nz-switch>
          </div>
         
          <!-- Option màu nền cho frame -->
          <app-background-image-config
                [config]="config"
                [class]="class"
                [backgroundClass]="class['frame-news-group']"
                [backgroundConfig]="config['frame-news-group']"
                [id_object]="objectChoosing._id"
                [isBlock]="false"
                [device]="device">
          </app-background-image-config>
          <!-- Cho phép slide -->
          <app-slide-config
                [config]="config"
                [class]="class"
                [slideConfig]="config['frame-news-group__products']"
                [id_object]="objectChoosing._id"
                [device]="device"
          >
          </app-slide-config>
        </div>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="Cấu hình chung" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-total-row-col-products-config
                [config]="config"
                [class]="class"
                [productsClass]="class['frame-news-group__products']"
                [productsConfig]="config['frame-news-group__products']"
                [id_object]="objectChoosing._id"
                [device]="device"
        >
        </app-total-row-col-products-config>
      </li>
      <!-- Cấu hình {{'duong_vien_chung' | translate}} -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [device]="device"
                            [class]="class" [elementChoosing]="objectChoosing"
                            [borderClass]="class['frame-news-group']"
                            [id_object]="objectChoosing._id"
        >
        </app-borders-config>
        <!-- Cấu hình bo tròn viền -->
        <div class="item-border-radius">
          <div class="slide-bar d-flex justify-content-between align-items-center">
            <p class="m-0 title-border">Bo tròn</p>
            <input class="input-number" type="text" [ngModel]="class['frame-news-group']['border-radius']| vhpercent"
              #widthvalue (ngModelChange)="class['frame-news-group']['border-radius'] = $event;"
              (blur)="class['frame-news-group']['border-radius'] = widthvalue.value; updateClass()" />
          </div>
          <nz-slider [ngModel]="class['frame-news-group']['border-radius']| vhnumber" [nzMin]="0" 
            [nzStep]="1" (nzOnAfterChange)="updateClass()"
            (ngModelChange)="class['frame-news-group']['border-radius'] = $event+'%';"></nz-slider>
        </div>
        <!-- Nút {{'mo_rong' | translate}} -->
        <div class="mr-2 mb-4 view-more">
          <p class="discover_text" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="Cấu hình phần tử" [(nzOpen)]="openMenu.menu4" (nzOpenChange)="openHandler('menu4')">
         <div class="main-config">
            <app-borders-config [device]="device"
                              [class]="class" [elementChoosing]="objectChoosing"
                              [borderClass]="class['frame-news-group__products--item']"
                              [id_object]="objectChoosing._id"
            >
            </app-borders-config>
          <div class="mr-2 mt-2 mb-4 view-more">
            <p class="discover_text" (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li nz-submenu nzTitle="Cấu hình icon trái" [(nzOpen)]="openMenu.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-icon-left-config
                    [device]="device"
                    [class]="class"
                    [config]="config"
                    [iconLeftClass]="class['frame-news-group__left-arrow--icon']"
                    [iconLeftConfig]="config['frame-news-group__left-arrow--icon']"
                    [distanceLeftClass]="class['frame-news-group__left-arrow']"
                    [id_object]="objectChoosing._id"
                >
        </app-icon-left-config>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li nz-submenu nzTitle="Cấu hình icon phải" [(nzOpen)]="openMenu.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-icon-right-config
                    [device]="device"
                    [class]="class"
                    [config]="config"
                    [iconRightClass]="class['frame-news-group__right-arrow--icon']"
                    [iconRightConfig]="config['frame-news-group__right-arrow--icon']"
                    [distanceRightClass]="class['frame-news-group__right-arrow']"
                    [id_object]="objectChoosing._id"
                >
        </app-icon-right-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-news-group']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-news-group__products--item']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
      <!-- Bật đổ bóng -->
      <app-shadow-config 
            [device]="device"
            [config]="config"
            [class]="class"
            [shadowClass]="class['frame-news-group__products--item']"
            [shadowConfig]="config['frame-news-group__products--item']"
            [objectChoosing]="objectChoosing"
            >
      </app-shadow-config>
    </div>
  </div>
</div>
